import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";

import SendMailWidget from "../../widgets/SendMailWidget";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import GetStudenti from "../../services/getStudenti";
import DeleteStudente from "../../services/deleteStudente";
import addNotification from "../../services/addNotification";
import sendMail from "../../services/sendMail";
import saveFile from "../../services/saveFile";
import getSetting from "../../services/getSetting";
import Utils from "../../utils/utils";
import getLezioni from "../../services/getLezioni";
import getAssenzeNonGiustificate from "../../services/getAssenzeNonGiustificate";
import getCorsi from "../../services/getCorsi";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import blackListStudente from "../../services/addBlackList";

export default class Studenti extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [],
      corsi: [],
      selectedCategoria: null,
      selectedCorsi: null,
      optionsCategoria: [],
      studentiFiltrati: [],
      studenti: [],
      corsiAssociati: [],
    };

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.pageTitle = "Studenti";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({ list: [] });
    cookies.set("checksList", strJson, { path: "/" });

    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
    this.handleCorsiChange = this.handleCorsiChange.bind(this);

    this.state = {
      studenti: [],
    };
  }

  handleCategoriaChange(option) {
    this.setState({ selectedCategoria: option, selectedCorsi: null }, () => {
      this.reload();
    });
  }

  handleCorsiChange(option) {
    this.setState({ selectedCorsi: option }, () => {
      this.reload();
    });
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.studenti = await GetStudenti(username, token, true); // include_disabled=true per mostrare anche studenti sospesi
    this.lezioni = await getLezioni(username, token);
    this.assenze = await getAssenzeNonGiustificate(username, token);
    this.corsi = await getCorsi(username, token);
    this.categorieCorsi = await getCategorieCorsi(username, token);

    const studentiConCorsi = this.studenti.map((studente) => {
      const corsiIds = studente.corsi.split(";").filter(Boolean);
      const corsiNomi = corsiIds
        .map((id) => {
          const corso = this.corsi.find((c) => c.id == id);
          return corso ? corso.name : null;
        })
        .filter(Boolean)
        .join(", ");

      const corsiRitiroIds = studente.corsi_ritiro
        ? studente.corsi_ritiro.split(";").filter(Boolean)
        : [];

      const corsiRitiroNomi = corsiRitiroIds
        .map((id) => {
          const corso = this.corsi.find((c) => c.id == id);
          return corso ? corso.name : null;
        })
        .filter(Boolean)
        .join(", ");

      return {
        ...studente,
        corsiNomi,
        corsiRitiroNomi,
      };
    });

    const { selectedCategoria, selectedCorsi } = this.state;
    let studentiFiltrati = [...studentiConCorsi];

    if (selectedCategoria?.value !== "seleziona tutti" && selectedCategoria) {
      studentiFiltrati = studentiFiltrati.filter((studente) => {
        const corsiStudenteIds = studente.corsi
          ? studente.corsi.split(";").map((id) => Number(id.trim()))
          : [];
        const corsiAssociatiStudente = corsiStudenteIds
          .map((idCorso) => this.corsi.find((corso) => corso.id === idCorso))
          .filter(Boolean);
        return corsiAssociatiStudente.some(
          (corso) => corso.id_categoria === selectedCategoria.value
        );
      });
    }

    if (selectedCorsi?.value !== "seleziona tutti" && selectedCorsi) {
      const corsoId = selectedCorsi.value;
      studentiFiltrati = studentiFiltrati.filter((studente) => {
        return studente.corsi
          ? studente.corsi
              .split(";")
              .map((id) => Number(id.trim()))
              .includes(corsoId)
          : false;
      });
    }

    let corsiAssociati = [];
    if (selectedCategoria && selectedCategoria.value !== "seleziona tutti") {
      corsiAssociati = this.corsi.filter(
        (corso) => corso.id_categoria === selectedCategoria.value
      );
    }

    const corsiAssociatiFormat = corsiAssociati.map((corso) => ({
      value: corso.id,
      label: corso.name,
    }));

    this.studenti.forEach((s) => {
      const ass = this.assenze.filter((a) => a.id_studente === s.id);
      s.assenze_non_giustificate = ass.length;
    });

    const optionsCategoria = this.categorieCorsi.map((categoria) => ({
      value: categoria.id,
      label: categoria.name,
    }));

    this.setState({
      studenti: this.studenti,
      corsi: this.corsi,
      optionsCategoria: [
        { label: "SELEZIONA TUTTI", value: "seleziona tutti" },
        ...optionsCategoria,
      ],
      studentiFiltrati,
      corsiAssociati: [
        { label: "SELEZIONA TUTTI", value: "seleziona tutti" },
        ...corsiAssociatiFormat,
      ],
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    console.log("studneti", this.state.studenti);
    var headCells = [
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "mail", numeric: true, disablePadding: false, label: "Mail" },
      {
        id: "telefono",
        numeric: false,
        disablePadding: false,
        label: "Telefono",
      },
      {
        id: "corsiNomi",
        numeric: false,
        disablePadding: false,
        label: "Corsi",
      },
      {
        id: "corsiRitiroNomi",
        numeric: false,
        disablePadding: false,
        label: "Corsi Ritirati",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    const studentiFiltrati = this.state.studentiFiltrati || [];

    const corsiAssociati = this.state.corsiAssociati || [];

    this.searchCols = ["nome", "cognome", "mail", "telefono", "classe"];

    const studentBlacklist = this.state.studenti
      .filter((studente) => studente.blacklist === 1)
      .map((studente) => studente.id);

    const cookies = new Cookies();

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title={this.pageTitle}
            button="NUOVO"
            onClick={() => {
              window.location.href = "/#/app/addStudente";
            }}
          />

          <Table
            withBilling
            filtroCorsi
            headCells={headCells}
            searchCols={this.searchCols}
            categorie={this.state.optionsCategoria}
            corsiAssociati={corsiAssociati}
            selectedCategoria={this.state.selectedCategoria}
            selectedCorsi={this.state.selectedCorsi}
            assenze={false}
            blackList={studentBlacklist}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            pdf={false}
            excel={false}
            mail={true}
            phone={false}
            rows={studentiFiltrati}
            onEventClick={(row) => {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href = "/#/app/editStudente";
            }}
            onPdfClicked={(row) => {
              cookies.set("requestedStudent", row, { path: "/" });
              window.location.href = "/#/app/pdfSingleStudent";
            }}
            onSendMail={(id) => {
              this.sendMailRef.current && this.sendMailRef.current.reset();
              this.setState({ sendMailVisible: true, sendMailUserId: id });
            }}
            onSendNotification={(id) => {
              this.sendNotificationRef.current &&
                this.sendNotificationRef.current.reset();
              this.setState({
                sendNotificationVisible: true,
                notificationUser: id,
              });
            }}
            onBlacklistPressed={async (id) => {
              const studente = this.state.studenti.find(
                (studente) => studente.id === id
              );

              const isInBlacklist = studente && studente.blacklist === 1;
              const message = isInBlacklist
                ? "Sei sicuro di voler togliere lo studente dalla blacklist?"
                : "Sei sicuro di voler mettere in blacklist lo studente?";

              if (window.confirm(message) === false) return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              await blackListStudente(username, token, id);

              const alertMessage = isInBlacklist
                ? "Studente rimosso dalla blacklist"
                : "Studente aggiunto alla blacklist";
              window.alert(alertMessage);

              this.reload();
            }}
            // onDelete={async id => {
            // 	if (window.confirm("Sei sicuro di voler eliminare lo studente?") == false) return;

            // 	const cookies = new Cookies();
            // 	const username = cookies.get("username", { path: "/" });
            // 	const token = cookies.get("token", { path: "/" });
            // 	await DeleteStudente(username, token, id);
            // 	this.reload();
            // }}
            onElementCheck={async (companyId) => {
              const cookies = new Cookies();

              var json = cookies.get("checksList", { path: "/" });
              var checksList = json.list;
              var index = checksList.indexOf(companyId);
              if (index != -1) checksList.splice(index, 1);
              else checksList.push(companyId);

              cookies.set("checksList", JSON.stringify({ list: checksList }), {
                path: "/",
              });
            }}
            onAssenze={(row) => {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href = "/#/app/gestioneAssenze";
            }}
            onBilling={(id) => {
              cookies.set("currentStudente", id, { path: "/" });
              window.location.href = "/#/app/billing/studenteDetails";
            }}
          />

          {this.elementPdf ? this.elementPdf : null}
          <SendMailWidget
            ref={this.sendMailRef}
            show={this.state.sendMailVisible}
            onClose={() => this.setState({ sendMailVisible: false })}
            onSend={async (subject, body, file) => {
              this.setState({ waitDialogVisible: true });
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              this.mail = await getSetting(
                username,
                token,
                "sendingMailAddress"
              );
              this.mailPassword = await getSetting(
                username,
                token,
                "sendingMailPassword"
              );

              var studente = this.studenti.find(
                (s) => s.id == this.state.sendMailUserId
              );
              studente.mail = studente.mail.trim();

              let filePath = "";
              if (file != undefined) {
                console.log("Debug - Caricamento file:", file.name);
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
                console.log("Debug - Risposta saveFile:", this.filePath);
                // Rimuoviamo il punto iniziale dal percorso per evitare problemi
                filePath = this.filePath.name
                  ? this.filePath.name.replace(/^\.\//, "")
                  : "";
                console.log("Debug - Percorso file modificato:", filePath);
              }

              if (
                studente.mail != "" &&
                Utils.validateEmail(studente.mail) == false
              ) {
                alert("L'indirizzo " + studente.mail + " non è valido");
                this.setState({ waitDialogVisible: false });
                return;
              }

              if (studente.mail != "") {
                console.log("Debug - Invio email con allegato:", filePath);
                try {
                  const response = await sendMail(
                    username,
                    token,
                    this.mail,
                    "Accademia Nazionale del Cinema",
                    this.mailPassword,
                    studente.mail,
                    studente.nome + " " + studente.cognome,
                    filePath,
                    subject,
                    body
                  );
                  console.log("Debug - Risposta invio email:", response);
                  if (response === "OK") {
                    alert("Email inviata con successo");
                  } else {
                    alert(
                      "Ci sono stati problemi con l'invio dell'email. Controllare i log."
                    );
                  }
                } catch (error) {
                  console.error("Errore nell'invio dell'email:", error);
                  alert("Errore nell'invio dell'email: " + error.message);
                }
              }

              this.setState({ waitDialogVisible: false });
              this.setState({ sendMailVisible: false });
            }}
          />

          <SendNotificationWidget
            ref={this.sendNotificationRef}
            show={this.state.sendNotificationVisible}
            onClose={() => this.setState({ sendNotificationVisible: false })}
            onSend={async (subject, body, bodyFull) => {
              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });

              await addNotification(
                username,
                token,
                "STUDENTE",
                this.state.notificationUser,
                subject,
                body,
                bodyFull,
                0
              );

              this.setState({ waitDialogVisible: false });
              this.setState({ sendNotificationVisible: false });
            }}
          />

          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </>
    );
  }
}
